import { render, staticRenderFns } from "./b-input.vue?vue&type=template&id=5be9a635&"
import script from "./b-input.vue?vue&type=script&lang=js&"
export * from "./b-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports